import { Route, Routes } from 'react-router-dom';
import PortalForm from '../pages/sys/PortalForm';
import InvoicePage from '../pages/sys/Invoice';
import PrintTableWithHeader from '../components/PrintReport';
import ActivityReport from '../pages/sys/ActivityReport';
import UserPermission from '../pages/users/UserPermission';
import QrCodeProfile from '../pages/sys/QrCodeProfile';
import MultiRowPrint from '../pages/caafi/MultiRowPrint';
import SummaryCategoryLetter from '../pages/caafi/Summary_category_letter';
import MaternityDeliveryNote from '../pages/caafi/DelivertNote';
import InvoiceBook from '../pages/web/KaafiPay/InvoiceBook';
import CancelReceipt from '../pages/aqoonkaal/CancelReceipt';
import CancelBusReceipt from '../pages/aqoonkaal/CancelBusReceipt';
import GenerateQrCode from '../pages/custom/GenerateQrCode';
import { ComplaintLetter } from '../components/ComplaintLetter';
import DetailCategoryLetter from '../pages/caafi/Detail_category_Letter';
import PosInvoice from '../pages/pos/PosInvoice';
import StudentReceiptInvoice2 from '../pages/aqoonkaal/ReceiptInvoice2';
import StudentReceiptInvoice from '../pages/aqoonkaal/ReceiptInvoice';
import ApiDocumentation from '../pages/sys/ApiDocumentation';

 export const OtherRoutes = [
  <Route key="portal" path="/portal/:route" element={<PortalForm />} />,
  <Route key="invoice" path="/invoice/:route/:id" element={<InvoicePage />} />,
  <Route key="print" path="/print" element={<PrintTableWithHeader />} />,
  <Route key="print-activity" path="/print-activity" element={<ActivityReport />} />,
  <Route key="permission" path="/form-report/permission/:route" element={<UserPermission />} />,
  <Route key="qrcode" path="/qrcode/:route/:id" element={<QrCodeProfile />} />,
  <Route key="multiRowPrint" path="/multiRowPrint/:route/:id" element={<MultiRowPrint />} />,
  <Route key="detailCategoryLetter" path="/detailCategoryLetter/:route/:id" element={<DetailCategoryLetter />} />,
  <Route key="summaryCategoryLetter" path="/summaryCategoryLetter/:route/:id" element={<SummaryCategoryLetter />} />,
  <Route key="MaternityDeliveryNote" path="/MaternityDeliveryNote/:id" element={<MaternityDeliveryNote />} />,
  <Route key="invoice-book" path="/invoice-book" element={<InvoiceBook />} />,
  <Route key="cancel-receipt" path="/cancel-receipt/:fee_id/:ref_no" element={<CancelReceipt />} />,
  <Route key="cancel-bus-receipt" path="/cancel-bus-receipt/:fee_id/:ref_no" element={<CancelBusReceipt />} />,
  <Route key="qr-code" path="/qr-code" element={<GenerateQrCode />} />,
  <Route key="complaint-letter" path="/complaint-letter/:route/:id" element={<ComplaintLetter />} />,
   <Route  key="pos-invoice" path="/pos-invoice/:route/:id" element={<PosInvoice />} />,
    <Route
    key="student-invoice1"
        path="/student-invoice/:route/:id"
        element={<StudentReceiptInvoice />}
      />,
      <Route
      key="student-invoice2"
        path="/student-invoice/:route/:fee_id/:id"
        element={<StudentReceiptInvoice2 />}
      />,
       <Route key="api-documentation"
        path="/api-documentation/:link_id"
        element={<ApiDocumentation />}
      />
   
  
];